import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CreateForm } from "./CreateForm";
import { Form } from "react-bootstrap";

import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { useTranslation } from "react-i18next";
import { IPage } from "../interface";
import { AdminPageService } from "../service";

export const UpdatePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const { t } = useTranslation();
  const [state, setState] = useState<IPage>({
    title: "",
    text: "",

    category: { name: "" },
  });

  const submitHandler = () => {
    AdminPageService.update(state, +id!)
      .then((response) => {
        SuccessToast(t(`settings.successfully_saved`));
        navigate("/admin/page");
      })
      .catch((error) => ErrorToast(error));
  };

  return (
    <div className="col-12">
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          submitHandler();
        }}
      >
        <CreateForm categories={categories} state={state} setState={setState} />
      </Form>
    </div>
  );
};
